module.exports = __webpack_public_path__ + "static/media/doctor.15b5896c.png";